<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true" class="filter-form">
      <el-form-item label="客户姓名：">
        <el-input v-model="query.realName" placeholder="请输入客户姓名" clearable size="small" style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item label="客户电话：">
        <el-input v-model="query.phone" placeholder="请输入客户电话" clearable size="small" style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item label="区域：">
        <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small" style="width: 200px;"></el-cascader>
      </el-form-item>
      <el-form-item label="身份：">
        <el-select v-model="query.customerLevelId" placeholder="请选择" clearable size="small" style="width: 140px;">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import customerLevelApi from '@/api/sys/customerLevel'
import sysAddrApi from '@/api/sys/sysAddr'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      standingList:[],
      addressList: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true,
      }
    }
  },
  created() {
    // this.sectionList=JSON.parse(localStorage.getItem('levelList'))
    this.getBusinessStanding()
    this.getOption()
    this.getAddressList()
  },
  methods: {
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.standingList.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取客户
    getOption() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.standingList.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          data[i].child = undefined;
        } else {
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    handleDownload() {
      let query = {}
      if (this.query.realName) query.realName = this.query.realName
      if (this.query.phone) query.phone = this.query.phone
      if (this.query.customerLevelId) query.customerLevelId = this.query.customerLevelId
      if (this.dateTime && this.dateTime.length > 0) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.query.addrid && this.query.addrid.length) {
        query.provinceCode = this.query.addrid[0]
        if (this.query.addrid.length > 1) {
          query.cityCode = this.query.addrid[1]
        }
        if (this.query.addrid.length > 2) {
          query.areaCode = this.query.addrid[2]
        }
      }
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.ExportExcels(query)).then((res) => {
          if (res.code === '0') {
            this.$common.showMsg('success', '导出任务已创建，请稍后刷新下载')
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style scoped>
.filter-form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
::v-deep .el-form-item {
  margin-bottom: 4px;
  margin-right: 12px;
}
</style>
